import {loadIfNeeded} from '../gdpr';

type CMPSdkApi = (command: string, parameter?: string, callback?: (value: boolean, success: boolean) => void) => void;

interface GDPRWindow extends Window {
  __cmp?: CMPSdkApi;
  __uspapi?: CMPSdkApi;
  __tcfapi?: CMPSdkApi;
  openUi?: CMPSdkApi;
}

const openSettings = () => {
  const win = window as GDPRWindow;

  if (win.__tcfapi && win.openUi) {
    win.openUi('Level2');
  } else {
    const cmpApi = win.__uspapi || win.__cmp;

    if (cmpApi) {
      cmpApi('openSettings');
    }
  }
};

export const initSettingsLinks = async () => {
  await loadIfNeeded({render: false});

  const links: HTMLElement[] = Array.from(document.querySelectorAll('[data-gdpr-settings-link]'));

  for (const link of links) {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      openSettings();
    });
  }
};
